import { Component } from '@theme/component'

export class AnnouncementBar extends Component {
  constructor() {
    super()
  }

  async connectedCallback() {
    await this.loadGSAP()
    this.init()
  }

  async loadGSAP() {
    if (typeof window.gsap === 'undefined') {
      return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src =
          'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js'
        script.onload = resolve
        document.head.appendChild(script)
      })
    }
  }

  init() {
    const closeButton = this.querySelector('#announcement-close-button')
    const newsletterTrigger = this.querySelector('#newsletter-trigger-button')
    const announcementBar = document.querySelector('.announcement-bar')

    console.log('Announcement Bar loaded', closeButton)

    if (closeButton && announcementBar) {
      closeButton.addEventListener('click', () => {
        this.closeAnnouncementBar(announcementBar)
      })
    }

    if (newsletterTrigger) {
      newsletterTrigger.addEventListener('click', () => {
        this.openNewsletterModal()
      })
    }

    // Add is-first class when this announcement bar is the first section on the page
    if (announcementBar) {
      const announcementBarComponent = announcementBar.querySelector(
        'announcement-bar-component'
      )
      if (
        announcementBarComponent &&
        this.#isFirstSection(/** @type {HTMLElement} */ (announcementBar))
      ) {
        announcementBarComponent.classList.add('is-first')
      }
    }

    // Monitor sticky state changes
    if (announcementBar) {
      this.#observeStickyState(announcementBar)
    }
  }

  /**
   * Determine if the announcement bar section is the first section element on the page
   * (ignoring non-section siblings like scripts or text nodes).
   * @param {HTMLElement} sectionEl
   * @returns {boolean}
   */
  #isFirstSection(sectionEl) {
    let prev = sectionEl.previousElementSibling

    while (prev) {
      // Treat any previous element sibling as a preceding section container
      // (Shopify may wrap sections in various tags, but order is what matters).
      return false
    }

    return true
  }

  #observeStickyState(element) {
    // Use ResizeObserver on parent to detect sticky positioning changes
    let lastScrollY = 0
    let isSticky = false

    const checkStickyState = () => {
      const rect = element.getBoundingClientRect()
      const announcementBarComponent = element.querySelector(
        'announcement-bar-component'
      )
      if (!announcementBarComponent) return

      // Element is sticky when its top is at or near 76px (the sticky top value)
      const shouldBeSticky =
        window.scrollY > 0 && rect.top <= 76 && rect.top >= 0

      if (shouldBeSticky && !isSticky) {
        isSticky = true
        announcementBarComponent.classList.add('is-sticky')
      } else if (!shouldBeSticky && isSticky) {
        isSticky = false
        announcementBarComponent.classList.remove('is-sticky')
      }
    }

    // Check on scroll
    window.addEventListener('scroll', checkStickyState, { passive: true })
    // Check on load
    checkStickyState()
  }

  openNewsletterModal() {
    const newsletterModal = document.querySelector('newsletter-form')
    if (newsletterModal && typeof newsletterModal.forceShow === 'function') {
      // Force show the modal (even if previously dismissed)
      newsletterModal.forceShow()
      console.log('Opening newsletter modal from announcement bar')
    } else if (newsletterModal) {
      // Fallback: manually show the modal
      newsletterModal.classList.remove('hidden')
      newsletterModal.classList.add('show')
      console.log('Opening newsletter modal from announcement bar (fallback)')
    } else {
      console.warn('Newsletter modal not found on page')
    }
  }

  closeAnnouncementBar(element) {
    // Using GSAP for smooth animation
    window.gsap.to(element, {
      height: 0,
      duration: 0.6,
      ease: 'power2.out',
      onComplete: () => {
        element.style.display = 'none'
      }
    })
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar)
}
